module.exports = __webpack_public_path__ + "02_mole.77215d9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/02_mole.png
// module id = 6UGC
// module chunks = 0